import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import CAppComponent from "./capp-component";

class Forbidden extends CAppComponent {

    render() {
        const { auth, intl } = this.props;
        const { user } = auth;

        return (
            <div className="main-content-menuless bg-gray forbidden-hint">
                <div className="py-5"></div>
                <div className='container pt-5 pb-5'>
                    <h1><FormattedMessage id={'app.auth.forbidden.title'}/></h1>
                    <h2 class="pt-4"><strong><FormattedMessage id={'app.auth.forbidden.message'}/></strong></h2>
                    <hr/>
                    <h3>
                        <FormattedMessage id={'app.auth.currently_signed_in_as'}/>
                    </h3>
                    <strong>{ user.uid }</strong> { (user.email !== user.uid) && user.email }
                    <p class="pt-5">
                        <FormattedMessage id={'app.auth.try_different_sigin'}/>
                        <a href="/">
                            { user.provider === 'email' && intl.formatMessage({id: 'app.auth.provider.email'}) }
                            { user.provider === 'moje.gridservices.cz' && intl.formatMessage({id: 'app.auth.provider.candidate'}) }
                            { user.provider === 'login.gasnet.cz' && intl.formatMessage({id: 'app.auth.provider.employee'}) }
                            { user.provider === 'https://sts.windows.net/4d3392af-c9b5-4356-a1eb-720bd08dcdae/' && intl.formatMessage({id: 'app.auth.provider.employee'}) }
                        </a>
                    </p>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(Forbidden));
